import type { VariantLoadingTextProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass } from '../helper';
import '../index.less';

function TextBlinkLoading({ text = 'Thinking', className, size = 'md' }: VariantLoadingTextProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__text-blink', getSizeClass(size), className)}>{text}</div>
  );
}

const TextBlinkLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingTextProps>(TextBlinkLoading);
TextBlinkLoadingComponent.displayName = 'TextBlinkLoading';

export default TextBlinkLoadingComponent;
